import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {MethodsHelper} from "@app/helpers/methods.helper";
import {BranchService} from "@app/services/branch.service";
import {NotificationService} from "@app/services/notification.service";
import {PrintingFormsService} from "@app/services/printing-forms.service";
import {PrintingForms} from "@app/models/printing-forms";
import { AuthenticationService } from "@app/services/authentication.service";
import { Branch } from "@app/models/branch";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-print-receipt-popup',
    templateUrl: 'print-receipt-popup.component.html',
    styleUrls: ['print-receipt-popup.component.css'],
    standalone: false
})

export class PrintReceiptPopupComponent implements OnInit {

    @Input() id: string;
    @Input() type: string;
    @Input() displayDialog: boolean;
    @Input() title: string = "Print agreement";
    @Output() onSubmit = new EventEmitter();
    @Output() onCancel = new EventEmitter();

    @ViewChild('form') form: any;

    submittedForm: boolean = false;

    validationMessages: object;

    branches: Array<Branch>;
    branchId: string;
    selectedPrintingForm: PrintingForms;

    pageIndex = 0;
    pageSize = 9999;
    totalElements: number;

    defaultPageParams = {
        size: 10,
        page: 0
    }

    printingFormsList: Array<PrintingForms>;

    constructor(
        private branchService: BranchService,
        private notificationService: NotificationService,
        private printingFormsService: PrintingFormsService,
        private authenticationService: AuthenticationService,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        this.validationMessages = new Object();
        this.getBranches();
        this.getPrintingFormsList();
        this.branchId = this.authenticationService.getCurrentBranchId();
    }

    getPrintingFormsList() {

        const pageOption = {
            size: this.pageSize,
            page: this.pageIndex
        }

        const pageParams = { ...this.defaultPageParams, ...pageOption };
        this.printingFormsService.getList(pageParams).subscribe({
            next: (data) => {
                let printingForms = data.content.filter(p => p.status === 'ACTIVE');
                this.totalElements = data.totalElements;
                
                switch (this.type.toUpperCase()) {
                    case 'LOANS':
                        this.printingFormsList = printingForms.filter(p => p.operationGroup === this.type.toUpperCase());
                        break;
                    case 'LOAN_AGREEMENT':
                        this.printingFormsList = printingForms.filter(p => p.operationGroup === 'LOANS' && p.operation !== 'GROUP_LOANS_AGREEMENT');
                        break;
                    case 'GROUP_LOANS_AGREEMENT':
                        this.printingFormsList = printingForms.filter(p => p.operation === this.type.toUpperCase());
                        break;
                    case 'DEPOSIT_AGREEMENT':
                        this.printingFormsList = printingForms.filter(p => p.operationGroup === 'DEPOSITS');
                        break;
                    case 'ORDERS_MEMORIAL':
                    case 'ORDERS_CASH_IN':
                    case 'ORDERS_CASH_OUT':
                    case 'ORDERS_BANK_TRANSFER':
                    case 'ORDERS_OFF_BALANCE_DEBIT':
                    case 'ORDERS_OFF_BALANCE_CREDIT':
                    case 'ORDERS_EXCHANGE':
                        this.printingFormsList = printingForms.filter(p => p.operationGroup === 'ORDERS' && p.operation.toUpperCase() === this.type.toUpperCase());
                        break;
                    case 'SAVINGS':
                        this.printingFormsList = printingForms.filter(p => p.operationGroup === 'SAVINGS');
                        break;
                    case 'COLLATERALS':
                        this.printingFormsList = printingForms.filter(p => p.operationGroup === 'COLLATERALS');
                        break;
                    case 'GUARANTEES':
                        this.printingFormsList = printingForms.filter(p => p.operationGroup === 'GUARANTEES');
                        break;
                    default:
                        this.printingFormsList = printingForms;
                }

                if (this.printingFormsList && this.printingFormsList.length > 0) {
                    this.selectedPrintingForm = this.printingFormsList[0];
                } else {
                    this.selectedPrintingForm = undefined;
                }
            },
            error: (err) => {
                let errorMessage
                if (err?.error && MethodsHelper.isValidJSONString(err.error)) {
                    errorMessage = JSON.parse(err.error).message;
                } else {
                    errorMessage = MethodsHelper.findMessageException(err);
                }
                this.notificationService.showError("<i class='fa fa-times-circle'></i> <p>" + `${errorMessage}` + "</p>", "", 9000000);
            }
        });
    }

    getBranches() {
        const pageOption = {
            size: 10000,
            page: 0
        }
        const pageParams = { ...pageOption };
        this.branchService.getList(pageParams).subscribe(data => {
            this.branches = data.content;
        });
    }

    onSave() {
        this.saveData();
    }

    saveData() {        
        this.getFileFromServer(false);
    }

    onDownload(){
        this.getFileFromServer(true);
    }

    validateForm() {
        for (let key in this.validationMessages) {
            if (this.validationMessages[key]) {
                return false;
            }
        }
        if (this.form.form) {
            return this.form.form.valid && this.selectedPrintingForm;
        }
        return false;
    }

    getFileFromServer(isDownload) {
        this.submittedForm = true;

        var selectedBranchCode = this.branches.find(b => b.id === this.branchId)?.code;

        if (this.validateForm()) {
            let submittedData = {
                printingFormId: this.selectedPrintingForm.id,
                branchCode: selectedBranchCode,
                isPDF:!isDownload
            };

            this.printingFormsService.generatePrintingForm(this.id, submittedData).subscribe({
                next: (data) => {
                    let time = (localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date()).toISOString().slice(0, 10).replace(/-/g, "");
                    this.onSubmit.emit();

                    if (isDownload) {
                        let typeOfBlob = "octet-stream";
                        let extension = "";
                        if (this.selectedPrintingForm.defaultFormat === "PDF") {
                            typeOfBlob = 'application/pdf';
                            extension = '.pdf';
                        } else if (this.selectedPrintingForm.defaultFormat === "DOCX") {
                            typeOfBlob = 'application/docx';
                            extension = '.docx';
                        }
                        const blob = new Blob([data], { type: typeOfBlob });
                        const objectUrl = URL.createObjectURL(blob);
                        let link = document.createElement('a');
                        link.href = objectUrl;
                        link.download = 'printing-form_' + time + extension;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    } else {
                        const blob = new Blob([data], { type: 'application/pdf' });
                        const objectUrl = URL.createObjectURL(blob);
                        const newWindow = window.open(objectUrl, '_blank');
                        newWindow.focus();
                        newWindow.print();
                    }
                },
                error: (error) => {
                    MethodsHelper.showErrorMessageBlob(error)
                        .then((message) => {
                            this.notificationService.showError("<i class='fa fa-times-circle'></i> <p>" +
                                `${message}` + "</p>", "");
                        })
                        .catch((error) => {
                            throw error;
                        });
                    }
            });
        } else {
            this.notificationService.showErrorMessage(this.translate.instant('error.something_incorrect')) }
    }

    cancel() {
        this.onCancel.emit();
    }
}